import { FormattedMessage } from 'react-intl';

import type { ProductType } from '../api/product/types';
import { ProductTypedFormattedMessage } from './ProductTypedFormattedMessage';
import { extractUrlParameters } from './urlUtils';

interface Props {
    showPrice: boolean;
    monthPrice: string | undefined;
    productType: ProductType;
}

export const BuyButtonPriceLabel = (props: Props) => {
    const { showPrice, monthPrice, productType } = props;
    const { noPrice, notResponsive, buttonLeft } = extractUrlParameters(window.location.href);

    if (noPrice) {
        return <>{!notResponsive && <div className={'buyButtonPrice'} />}</>;
    }

    const content = !showPrice ? null : !monthPrice ? (
        <div className='text-size-14 line-height-20 text-medium label label-success label-filled'>
            <FormattedMessage id={'marketplace.buybutton.free'} />
        </div>
    ) : (
        <div className='display-flex flex-column align-items-start height-20'>
            <span className='text-size-20 line-height-20 text-medium'>{monthPrice}</span>
            <span className='text-size-12'>
                <ProductTypedFormattedMessage
                    productType={productType}
                    userBasedId='marketplace.buybutton.price.user.month'
                    assetBasedId='marketplace.buybutton.price.vehicle.month'
                />
            </span>
        </div>
    );
    return (
        <div className={`buyButtonPrice ${buttonLeft ? 'display-flex flex-column align-items-end' : ''}`}>
            {content}
        </div>
    );
};
